export default {"src":"/_next/static/media/IconArrowChevronLeftWhite.9bf4df2d.svg","height":20,"width":11,"blurWidth":0,"blurHeight":0};